<div class="bg-bg-base">
  <section class="relative overflow-hidden py-10">
    <div class="pointer-events-none absolute inset-0 overflow-hidden">
      <div class="absolute -right-44 -top-44 h-96 w-96 rounded-full bg-primary/5 blur-3xl"></div>
      <div
        class="absolute -bottom-44 -left-44 h-96 w-96 rounded-full bg-primary-deep/5 blur-3xl"
      ></div>
    </div>
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="relative mb-12 text-center">
        <h2
          class="mb-3 bg-primary bg-clip-text text-3xl font-bold text-transparent md:text-4xl leading-normal"
        >
          {{ 'home.topAreas.title' | translate }}
        </h2>
        <p class="mx-auto max-w-2xl text-text-secondary">{{ 'home.topAreas.subtitle' | translate }}</p>
      </div>

      <div *ngIf="isLoading" class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        <div
          class="h-64 animate-pulse rounded-2xl bg-surface-elevated"
          *ngFor="let item of [1, 2, 3]"
        ></div>
      </div>

      <div
        *ngIf="!isLoading && !errorMessage"
        class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3"
      >
        <app-top-area-card
          *ngFor="let area of topAreas"
          [areaName]="area.area"
          [propertiesCount]="area.propertiesCount"
          [thumbnail]="area.thumbnail"
          [isFeatured]="area.isFeatured"
        >
        </app-top-area-card>
      </div>

      <div
        *ngIf="!isLoading && errorMessage"
        class="rounded-2xl border border-danger bg-danger/10 p-4 text-center text-sm text-danger"
      >
        {{ errorMessage }}
      </div>

      <!-- Bottom cards -->
      <div class="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
        <div
          class="cursor-pointer surface-card p-6 text-center transition-all duration-300 hover:-translate-y-1 hover:border-primary/50"
        >
          <div class="text-4xl mb-3 text-primary">
            <i class="fa-solid fa-umbrella-beach"></i>
          </div>
          <h3 class="mb-2 font-semibold text-text-primary">
            {{ 'home.topAreas.cards.chalets.title' | translate }}
          </h3>
          <p class="text-text-secondary text-sm">
            {{ 'home.topAreas.cards.chalets.description' | translate }}
          </p>
        </div>

        <div
          class="cursor-pointer surface-card p-6 text-center transition-all duration-300 hover:-translate-y-1 hover:border-primary/50 ring-1 ring-primary/20"
        >
          <div class="text-4xl mb-3 text-primary">
            <i class="fa-solid fa-couch"></i>
          </div>
          <h3 class="mb-2 font-semibold text-text-primary">
            {{ 'home.topAreas.cards.furnished.title' | translate }}
          </h3>
          <p class="text-text-secondary text-sm">
            {{ 'home.topAreas.cards.furnished.description' | translate }}
          </p>
        </div>

        <div
          class="cursor-pointer surface-card p-6 text-center transition-all duration-300 hover:-translate-y-1 hover:border-primary/50"
        >
          <div class="text-4xl mb-3 text-primary">
            <i class="fa-solid fa-gift"></i>
          </div>
          <h3 class="mb-2 font-semibold text-text-primary">
            {{ 'home.topAreas.cards.deals.title' | translate }}
          </h3>
          <p class="text-text-secondary text-sm">
            {{ 'home.topAreas.cards.deals.description' | translate }}
          </p>
        </div>
      </div>
    </div>
  </section>
</div>
